import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-check-list-item-items',
  templateUrl: './check-list-item-items.component.html',
  styleUrls: ['./check-list-item-items.component.css']
})
export class CheckListItemItemsComponent implements OnInit {
    public checkListItemKeyno: string;

    public setting?: Setting;

    public itemsListCheckLists: Item[] = [];

    public orderingAlphabetically = false;

    public orderingByType = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.checkListItemKeyno = this.stateService.getStateParams()['checklistitem_keyno'];
    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1360))[0];
    }

    private async loadCheckListItems() {
        if (!!this.checkListItemKeyno) {
            this.itemsListCheckLists = [];

            this.itemsListCheckLists = await this.datatask.Post(560, { checklistitem_keyno: this.checkListItemKeyno });
        }
    }

    public async orderAlphabetically() {
        if (!!this.checkListItemKeyno) {
            try {
                this.orderingAlphabetically = true;

                await this.datatask.Post(566, {
                    checklistitem_keyno: this.checkListItemKeyno,
                    orderbytype: '',
                    alpha: 'alpha'
                });

                this.loadCheckListItems();
            } finally {
                this.orderingAlphabetically = false;
            }
        }
    }

    public async orderByType() {
        if (!!this.checkListItemKeyno) {
            try {
                this.orderingByType = true;

                await this.datatask.Post(566, {
                    checklistitem_keyno: this.checkListItemKeyno,
                    orderbytype: 'orderby',
                    alpha: ''
                });

                this.loadCheckListItems();
            } finally {
                this.orderingByType = false;
            }
        }
    }

    private async init() {
        this.loadSetting();
        this.loadCheckListItems();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    filtervalue: string;
}
